/* Gaveta do carrinho (replica do UpCart do concorrente). Abre no icone do carrinho e ao
   adicionar produto: intercepta TODO form de /cart/add em CAPTURA (inclusive o do buy_buttons
   nativo, que o ATC copiado submete por form=) antes do JS do tema. Se o widget de kit
   (cl-kaching.js) deixou linhas em window.__clKachingLines, elas vao no lugar do form.
   Barra de frete gratis (limite em data-free, centavos), upsell vertical (data-ups). */
(function () {
  'use strict';
  var D, money = '{{amount}}', FREE = 6500;
  function fmt(c) {
    var n = (c / 100).toFixed(2), p = n.split('.');
    var a = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','), b = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return money.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, b + ',' + p[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, b)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, a)
      .replace(/\{\{\s*amount\s*\}\}/, a + '.' + p[1]);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(u, h) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'height=' + h; }
  var TRASH = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg>';

  function bubble(count) {
    document.querySelectorAll('#cart-icon-bubble').forEach(function (b) {
      var c = b.querySelector('.cart-count-bubble');
      if (!count) { if (c) c.remove(); return; }
      if (!c) { c = document.createElement('div'); c.className = 'cart-count-bubble'; b.appendChild(c); }
      c.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' items</span>';
    });
  }

  function rewards(cart) {
    var left = FREE - cart.total_price, pct = Math.max(0, Math.min(100, cart.total_price / FREE * 100));
    // como o UpCart dele: carrinho vazio mostra a barra cheia ("unlocked")
    if (!cart.item_count) { left = 0; pct = 100; }
    D.querySelector('[data-cl-cart-msg]').innerHTML = left > 0
      ? "You're " + esc(fmt(left)) + ' away from FREE shipping 📦' : "You've unlocked FREE shipping 🎉";
    D.querySelector('[data-cl-cart-bar]').style.width = pct + '%';
  }

  function render(cart) {
    D.classList.toggle('is-empty', !cart.item_count);
    D.querySelector('[data-cl-cart-count]').textContent = cart.item_count;
    rewards(cart);
    D.querySelector('[data-cl-cart-items]').innerHTML = cart.items.map(function (it, i) {
      var opts = it.product_has_only_default_variant ? '' : '<div class="cl-cart__opt">' +
        (it.options_with_values || []).map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' / ') + '</div>';
      var price = (it.original_line_price > it.final_line_price ? '<s>' + fmt(it.original_line_price) + '</s>' : '') + fmt(it.final_line_price);
      return '<div class="cl-cart__item" data-line="' + (i + 1) + '">' +
        '<a href="' + esc(it.url) + '"><img src="' + esc(img(it.image, 176)) + '" alt="' + esc(it.product_title) + '" width="88" height="88" loading="lazy"></a>' +
        '<div class="cl-cart__info"><a class="cl-cart__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + opts +
        '<div class="cl-cart__price">' + price + '</div>' +
        '<div class="cl-cart__qty"><button type="button" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
        '<span>' + it.quantity + '</span><button type="button" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div></div>' +
        '<button type="button" class="cl-cart__rm" data-q="0" aria-label="Remove ' + esc(it.product_title) + '">' + TRASH + '</button></div>';
    }).join('');
    D.querySelector('[data-cl-cart-total]').textContent = fmt(cart.total_price);
    bubble(cart.item_count);
    ups(cart);
  }

  // ---- upsell: os produtos que o UpCart dele oferece, fora os que ja estao no carrinho ----
  var upsKey = null;
  function ups(cart) {
    var wrap = D.querySelector('[data-cl-cart-ups]');
    if (!cart.items.length) { wrap.hidden = true; return; }
    var inCart = cart.items.map(function (x) { return x.handle; });
    var want = (D.getAttribute('data-ups') || '').split(',').filter(function (h) { return h && inCart.indexOf(h) < 0; });
    var key = want.join('|'); if (key === upsKey) return; upsKey = key;
    if (!want.length) { wrap.hidden = true; return; }
    Promise.all(want.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      ps = ps.filter(function (p) { return p && p.available; });
      if (!ps.length) { wrap.hidden = true; return; }
      D.querySelector('[data-cl-ups-list]').innerHTML = ps.map(function (p) {
        var vs = p.variants.filter(function (v) { return v.available; });
        var cmp = p.compare_at_price > p.price ? '<s>' + fmt(p.compare_at_price) + '</s>' : '';
        return '<div class="cl-cart__up"><a href="' + esc(p.url) + '"><img src="' + esc(img(p.featured_image, 180)) + '" alt="' + esc(p.title) + '" width="90" height="90" loading="lazy"></a>' +
          '<div class="cl-cart__up-info"><a class="cl-cart__up-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="cl-cart__up-price">' + cmp + fmt(p.price) + '</div><div class="cl-cart__up-row">' +
          '<select aria-label="Select ' + esc(p.title) + ' variant"' + (vs.length > 1 ? '' : ' hidden') + '>' + vs.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>' +
          '<button type="button" data-cl-up-add>Add</button></div></div></div>';
      }).join('');
      wrap.hidden = false;
    });
  }

  function get() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw r; return r.json(); }); }
  function refresh() { D.classList.add('is-loading'); return get().then(function (c) { render(c); D.classList.remove('is-loading'); return c; }).catch(function () { D.classList.remove('is-loading'); }); }
  function open() {
    var h = document.documentElement;
    h.classList.add('cl-cart-open'); document.body.classList.add('cl-cart-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { h.classList.add('cl-cart-anim'); }); });
    D.setAttribute('aria-hidden', 'false'); setTimeout(function () { D.focus(); }, 50);
    refresh();
  }
  function close() {
    var h = document.documentElement;
    h.classList.remove('cl-cart-anim');
    setTimeout(function () { h.classList.remove('cl-cart-open'); }, 280);
    document.body.classList.remove('cl-cart-lock'); D.setAttribute('aria-hidden', 'true');
  }
  function change(line, q) {
    D.classList.add('is-loading');
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: Math.max(0, q) }) })
      .then(function (r) { return r.json(); }).then(function (c) { render(c); D.classList.remove('is-loading'); }).catch(function () { D.classList.remove('is-loading'); });
  }
  function add(body, json) {
    return fetch('/cart/add.js', { method: 'POST', headers: json ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function boot() {
    D = document.getElementById('ClCartDrawer');
    if (!D) return;
    money = D.getAttribute('data-money') || money;
    FREE = +D.getAttribute('data-free') || FREE;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-cl-cart-close]')) { e.preventDefault(); close(); return; }
      var icon = t.closest('#cart-icon-bubble, a[href="/cart"], a[href$="/cart"]');
      if (icon && !icon.closest('#ClCartDrawer')) { e.preventDefault(); e.stopImmediatePropagation(); open(); return; }
      var q = t.closest('#ClCartDrawer [data-q]');
      if (q) { change(+q.closest('[data-line]').getAttribute('data-line'), +q.getAttribute('data-q')); return; }
      var ra = t.closest('[data-cl-up-add]');
      if (ra) {
        var sel = ra.parentElement.querySelector('select'); ra.disabled = true;
        add(JSON.stringify({ items: [{ id: +sel.value, quantity: 1 }] }), true)
          .then(function () { ra.disabled = false; upsKey = null; refresh(); }).catch(function () { ra.disabled = false; });
      }
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && document.documentElement.classList.contains('cl-cart-open')) close(); });
    // ATC: o JS do Shrine trata o CLIQUE do botao (fetch proprio, sem evento submit) — por isso
    // a gaveta intercepta o clique E o submit, em captura, antes do tema
    function doAdd(f, submitter) {
      var host = document.querySelector('[data-cl-kaching]'), K = host && host.__clKaching;
      var lines = (K && K.lines()) || window.__clKachingLines; window.__clKachingLines = null;
      var req = lines && lines.length ? add(JSON.stringify({ items: lines }), true) : add(new FormData(f, submitter || undefined));
      var fid = f.getAttribute('id') || 'x';  // f.id seria o <input name="id"> do form
      var btns = document.querySelectorAll('[form="' + fid + '"][type=submit], [id="' + fid + '"] [type=submit]');
      btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      req.then(function () { open(); }).catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Could not add to cart';
        var box = document.querySelector('.cl-pdp .product-form__error-message, .cl-pdp [class*="product-form__error-message"]');
        if (box) { box.textContent = msg; var w = box.closest('[class*="error-message-wrapper"]'); if (w) w.hidden = false; } else { alert(msg); }
      }).then(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
    }
    function isAdd(f) { return f && f.action && /\/cart\/add/.test(f.action); }
    document.addEventListener('click', function (e) {
      var sb = e.target.closest('button[type=submit], input[type=submit]');
      if (!sb || sb.disabled || !isAdd(sb.form)) return;
      e.preventDefault(); e.stopImmediatePropagation(); doAdd(sb.form, sb);
    }, true);
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!isAdd(f)) return;
      e.preventDefault(); e.stopImmediatePropagation(); doAdd(f, e.submitter);
    }, true);
    document.addEventListener('cl:cart:open', open);
    get().then(function (c) { bubble(c.item_count); }).catch(function () {});
    window.clCart = { open: open, close: close, refresh: refresh };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
